import React, { useState, useEffect } from 'react';

import BackButton from '../../components/BackButton';
import ImageUpload from '../../components/ImageUpload';
import CustomForm from '../../components/CustomForm';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import FixedButton from '../../components/FixedButton';
import useFormInput from '../../hooks/useFormInput';
import action from '../../store/action';
import { connect } from 'react-redux';
import { upload } from '../../api/upload';
import { createUserApi } from '../../api/user';
import config from '../../config';
import { createAccountList } from '../../utils/utils';
import { validEmail } from '../../utils/regex';
import { getAccountMethod } from '../../utils/api';
const options = [
  { value: 'borrower', label: 'Borrower' },
  { value: 'manager', label: 'Manager' },
  { value: 'broker', label: 'Broker' }
];

function UserCreate(props) {
  const { global_action_loading, accounts, set_accounts, accountsIsGet, add_user } = props;
  const [count, setCount] = useState(0);
  const [file, setFile] = useState();

  const first_name = useFormInput('', count);
  const last_name = useFormInput('', count);
  const title = useFormInput('', count);
  const email = useFormInput('', count);
  const phone = useFormInput('', count);
  const role = useFormInput('borrower');

  const accountsList = createAccountList(accounts, role.value);

  const [account_id, setAccount] = useState('');

  const onChange = event => {
    setAccount(event.target.value);
  };
  const sAccounts = JSON.stringify(accountsList);
  useEffect(() => {
    if (!accountsIsGet) {
      getAccountMethod(set_accounts, global_action_loading);
    }
  }, [accountsIsGet, set_accounts, global_action_loading]);

  useEffect(() => {
    setAccount(JSON.parse(sAccounts).length > 0 ? JSON.parse(sAccounts)[0].value : '');
  }, [sAccounts]);

  const submitUser = () => {
    if (!role.value || !phone.value || !last_name.value || !first_name.value || !email.value || !account_id) {
      alert('Please Enter Required Field');
      return;
    }
    if (!validEmail(email.value)) {
      alert('Wrong Email Format');
      return;
    }
    if (!file) {
      alert('Avatar Needed');
      return;
    }
    global_action_loading();
    const data = {
      title: title.value,
      role: role.value,
      phone: phone.value,
      first_name: first_name.value,
      last_name: last_name.value,
      email: email.value,
      account_id,
      password: '12345a',
      account_name: accountsList.filter(i => i.value === account_id)[0].label
    };

    upload({ file })
      .then(res => {
        if (res.data.status === 200) {
          const url = config.baseURL + 'uploads/' + res.data.filename;
          return url;
        } else {
          throw new Error('Image Update failed');
        }
      })
      .then(url => {
        data.avatar = url;
        return createUserApi(data);
      })
      .then(res => {
        if (res.data.status === 200) {
          data.id = res.data.data;
          add_user(data);
          setCount(count + 1);
          setFile();
          alert('Added Successfully!');
        } else {
          alert(res.data.message);
        }
        global_action_loading(false);
      })
      .catch(err => {
        alert('Error');
        global_action_loading(false);
      });
  };

  return (
    <React.Fragment>
      <BackButton path='user' />

      <ImageUpload file={file} setFile={setFile} />
      <CustomForm>
        <CustomInput {...email} label='Email' placeholder='Email Address' required />
        <CustomInput {...first_name} label='First Name' placeholder='First Name' required />
        <CustomInput {...last_name} label='Last Name' placeholder='Last Name' required />
        <CustomInput {...phone} label='Phone' placeholder='User Phone' required />
        <CustomSelect {...role} label='Role' options={options} />
        <CustomSelect value={account_id} onChange={onChange} label='Account' options={accountsList} />
        <CustomInput {...title} label='Title' placeholder='Title In Account' required />
      </CustomForm>
      <FixedButton onClick={submitUser}>Add User</FixedButton>
    </React.Fragment>
  );
}

export default connect(state => state.account, { ...action.globalLoading, ...action.user, ...action.account })(
  UserCreate
);
